module.exports = __webpack_public_path__ + "static/Akebia_MOD_Animation_03_Progression_of_Anemia_due_to_CKD-031d933e26bc613e95404d3ddca5b702.mp4";